exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tree-checkbox.checked {\n  background-color: #003a5d;\n  border-color: #003a5d;\n}\n.tree-checkbox.indeterminate {\n  background-color: #39b54a;\n  border-color: #003a5d;\n}\n.userPreferencesName {\n  color: #39b54a;\n  font-size: 14px;\n  font-weight: 700;\n}\n", ""]);

// exports
